import { useMutation } from '@tanstack/react-query';

import { uploadProfileImage } from '../api/user';

type UploadProfileImageVariables = {
  formData: FormData;
  signal?: AbortSignal;
};

export interface UseMutateUploadProfileImageOptions {
  onSuccess?: () => void | Promise<void>;
  onError?: () => void;
}

export function useMutateUploadProfileImage(
  options?: UseMutateUploadProfileImageOptions
) {
  return useMutation({
    mutationFn: ({ formData, signal }: UploadProfileImageVariables) =>
      uploadProfileImage(formData, signal),
    onSuccess: () => options?.onSuccess?.(),
    onError: () => {
      options?.onError?.();
    },
  });
}
